// @flow
import { put, call, takeLatest } from "redux-saga/effects";
import {
  SET_SECTION_TIME_REQUEST,
  SET_SECTION_TIME_REQUEST_SUCCESS,
  SET_SECTION_TIME_REQUEST_ERROR,
} from "../constants";
import axios from "../../../services/api";

function* setSectionTime(data) {
  const params = new URLSearchParams();
  params.append("induction_id", data.induction_id);
  params.append("section", data.section);
  params.append("totalseconds", data.totalseconds);

  try {
    const response = yield call(axios.post, "/induction-timer/", params);
    if (response.data.error) {
      yield put({
        type: SET_SECTION_TIME_REQUEST_ERROR,
        data: response.error,
      });
    } else {
      yield put({
        type: SET_SECTION_TIME_REQUEST_SUCCESS,
        data: response.data,
      });
    }
  } catch (error) {
    yield put({
      type: SET_SECTION_TIME_REQUEST_ERROR,
      data: error,
    });
  }
}

export default function* setSectionTimeSaga() {
  yield takeLatest(SET_SECTION_TIME_REQUEST, setSectionTime);
}
